import { reducerUserInfo } from '@src/hooks/useUserInfo';
import { reducerUserStatus } from '@src/hooks/useUserStatus';
import { reducerGetCredentials } from '@src/hooks/useGetCredentials';
import { reducerBreadcrumbs } from '@src/hooks/useBreadcrumbs';
import { reducerClaimSummary } from '@src/hooks/useClaimSummary';
import { reducerRegenerateSecret } from '@src/hooks/useRegenerateSecret';
import { reducerDocumentation } from '@src/hooks/useDocumentation';
import { reducerDocumentationV3 } from '@src/hooks/useDocumentationV3';
import { reducerFeedbackSubmission } from '@src/hooks/useFeedbackSubmission/reducerFeedbackSubmission';
import { reducerLeadGenerationApi } from '@src/hooks/useLeadGenerationApi';
import { reducerCalendarApi } from '@src/hooks/useCalendarApi';
import { reducerApiHealthCheck } from '@src/hooks/useApiHealthCheck';
import { reducerDSUserInfo } from '@src/hooks/useDsUserInfo';
import { reducerFetchTinApi } from '@src/hooks/useFetchTinApi';
import { reducerPostTinApi } from '@src/hooks/usePostTinApi';
import { reducerPatchTinApi } from '@src/hooks/usePatchTinApi';
import { reducerHolidayApi } from '@src/hooks/useHolidayApi';
import { reducerSaveAsDraftApi } from '@src/hooks/useSaveAsDraftApi';
import { reducerGetCommunicationAPI } from '@src/hooks/useGetCommunicationAPI';
import { reducerGetDraftApi } from '@src/hooks/useGetDraftApi';
import { reducerGetSentCommunicationApi } from '@src/hooks/useGetSentCommunicationApi';
import { reducerDeleteCommunicationAPI } from '@src/hooks/useDeleteCommunicationAPI';
import { reducerDeleteFile } from '@src/hooks/useDeleteFile';
import { reducerDownloadFile } from '@src/hooks/useDownloadFile';
import { reducerUploadFile } from '@src/hooks/useUploadFile';
import { reducerSendCommunicationApi } from '@src/hooks/useSendCommunicationApi/reducerSendCommunicationApi';
import { reducerGetUserAcceptanceTOU } from '@src/hooks/useGetUserAcceptanceTOU';
import { reducerPostUserAcceptanceTOU } from '@src/hooks/usePostUserAcceptanceTOU/reducerPostUserAcceptanceTOU';
import { reducerGenerateSecret } from '@src/hooks/useGenerateSecret';
import { reducerDeleteSecretAPI } from '@src/hooks/useDeleteSecretAPI';

export const reducers = {
  ...reducerUserStatus,
  ...reducerGetCredentials,
  ...reducerDeleteSecretAPI,
  ...reducerUserInfo,
  ...reducerBreadcrumbs,
  ...reducerClaimSummary,
  ...reducerDocumentation,
  ...reducerDocumentationV3,
  ...reducerRegenerateSecret,
  ...reducerGenerateSecret,
  ...reducerFeedbackSubmission,
  ...reducerLeadGenerationApi,
  ...reducerCalendarApi,
  ...reducerApiHealthCheck,
  ...reducerDSUserInfo,
  ...reducerFetchTinApi,
  ...reducerPostTinApi,
  ...reducerPatchTinApi,
  ...reducerHolidayApi,
  ...reducerSaveAsDraftApi,
  ...reducerGetCommunicationAPI,
  ...reducerGetDraftApi,
  ...reducerGetSentCommunicationApi,
  ...reducerDeleteCommunicationAPI,
  ...reducerDeleteFile,
  ...reducerDownloadFile,
  ...reducerUploadFile,
  ...reducerSendCommunicationApi,
  ...reducerGetUserAcceptanceTOU,
  ...reducerPostUserAcceptanceTOU,
};
